var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenu06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.23828C9.82031 3.23828 10.5234 3.53125 11.1094 4.11719C11.6953 4.70313 11.9883 5.41797 11.9883 6.26172C11.9883 7.08203 11.6953 7.78516 11.1094 8.37109C10.5234 8.95703 9.82031 9.25 9 9.25C8.17969 9.25 7.47656 8.95703 6.89062 8.37109C6.30469 7.78516 6.01172 7.08203 6.01172 6.26172C6.01172 5.41797 6.30469 4.70313 6.89062 4.11719C7.47656 3.53125 8.17969 3.23828 9 3.23828ZM9 10.7617C10.0781 10.7617 11.0742 10.9023 11.9883 11.1836C12.9258 11.4414 13.6641 11.8047 14.2031 12.2734C14.7422 12.7188 15.0117 13.2109 15.0117 13.75V15.2617H2.98828V13.75C2.98828 13.2109 3.25781 12.7188 3.79688 12.2734C4.33594 11.8047 5.0625 11.4414 5.97656 11.1836C6.91406 10.9023 7.92188 10.7617 9 10.7617Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu06);
export default __webpack_public_path__ + "static/media/icon_menu_06.b412756ef6bddedbeda9d52eb0b87f7a.svg";
export { ForwardRef as ReactComponent };